import { render, staticRenderFns } from "./FactureList.vue?vue&type=template&id=62915832&scoped=true"
import script from "./FactureList.vue?vue&type=script&lang=js"
export * from "./FactureList.vue?vue&type=script&lang=js"
import style0 from "./FactureList.vue?vue&type=style&index=0&id=62915832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62915832",
  null
  
)

export default component.exports